<template>
    <div class="components-container" id="mobileViewPort">
        <div id="mobileMode">
            <div id="titleArea">
                <div class="titleText">学分认定</div>
                <div class="titleButton">
                    <el-button class="custom-el-button" type="primary" @click="showHomePage">
                        <i class="el-icon-s-home"></i> 首页
                    </el-button>
                </div>
            </div>
            <div id="queryArea">
                <div class="filter-container">
                    <div class="formItem">
                        <el-input v-if="teaAuthVisible" v-model="queryForm.stuCode" placeholder="学号 / 姓名" clearable></el-input>
                        <el-input v-if="stuAuthVisible" v-model="queryForm.courseName" placeholder="原 / 现课程名称" clearable></el-input>
                    </div>
                    <div class="formItem text-center">
                        <el-button @click="handleFilter" type="gray"><i class="el-icon-search"></i> 查询</el-button>
                        <el-button @click="handleReset" type="gray"><i class="el-icon-refresh"></i> 重置</el-button>
                        <el-button @click="queryDialogVisible = true" type="primary"><i class="el-icon-more"></i> 更多</el-button>
                        <el-button @click="addRec" type="success"><i class="el-icon-circle-plus-outline"></i> 申请</el-button>
                    </div>
                </div>
            </div>
            <!-- 搜索内容弹框 -->
            <el-dialog id="queryDialog" class="formDialog" title="查询信息" width="90%" :visible.sync="queryDialogVisible">
                <el-row v-if="teaAuthVisible">
                    <el-input v-model="queryForm.stuCode" placeholder="学号 / 姓名" clearable></el-input>
                </el-row>
                <el-row>
                    <el-input v-model="queryForm.courseName" placeholder="原 / 现课程名称" clearable></el-input>
                </el-row>
                <el-row>
                    <el-select v-model="queryForm.auditState" placeholder="审核状态" clearable>
                        <el-option v-for="(item, index) in comboOption.auditState" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                        </el-option>
                    </el-select>
                </el-row>
                <div slot="footer" class="dialog-footer text-center">
                    <el-button type="gray" @click="handleFilter">查 询</el-button>
                    <el-button style="margin-left: 10px;" type="gray" @click="handleReset">重 置</el-button>
                    <el-button style="margin-left: 10px;" @click="queryDialogVisible = false">取 消</el-button>
                </div>
            </el-dialog>

            <div id="listArea" @scroll="handleScroll">
                <div v-if="tableData==null || tableData.length==0" class="cardTips">没有申请记录</div>
                <div class="cardMain" v-for="(item,index) in tableData" :key="index">
                    <div class="cardText">
                        <p><label for="">学&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号：</label>{{ item.stuCode }}</p>
                        <p><label for="">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名：</label>{{ item.stuName }}</p>
                        <p><label for="">课程代码：</label>{{ item.oriCourseCode }}</p>
                        <p><label for="">课程名称：</label>{{ item.oriCourseName }}</p>
                        <p><label for="">课程类型：</label>{{ item.oriCourseTypeName }}</p>
                        <div class="auditStateImg">
                            <img :src="loadStateImg(item)" alt="">
                        </div>
                    </div>
                    <div class="cardInput" >
                        <el-button v-if="item.submitState == '0'" type="warning" @click="modRec(item)">编辑</el-button>
                        <el-button v-if="item.submitState == '0'" type="success" @click="submitRec(item)">提交</el-button>
                        <el-button v-if="item.submitState == '0'" type="danger" @click="delRec(item)">删除</el-button>
                        <el-button v-if="item.submitState=='1' && item.auditAuth=='0'" type="primary" @click="showDetailInfo(item)">详情</el-button>
                        <el-button v-if="item.auditAuth == '1'" type="primary" @click="auditRec(item)">审核</el-button>
                        <el-button v-if="item.submitState=='1' || item.auditState!=''" @click="showAuditList(item)">审核信息</el-button>
                    </div>
                </div>
                <div v-if="total>2 && total>tableData.length" id="loadingTips">
                    <i class="el-icon-loading"></i>&nbsp;信息加载中，请稍候...
                </div>
            </div>

            <el-dialog id="mainDialog" class="formDialog" :title="dialogTitle" :visible.sync="dialogVisible" @closed="closeDialog" width="90%">
                <el-scrollbar id="mainDialogScroll" ref="mainDialogScroll">
                    <el-form ref="applyForm" :model="applyForm" label-width="84px" label-position="left" width="100%" :rules="curdRules">
                        <el-form-item label="编号" prop="id" v-show="false">
                            <el-input v-model="applyForm.id"></el-input>
                        </el-form-item>
                        <el-row v-show="teaAuthVisible && fieldVisible">
                            <el-form-item label="学生" prop="stuInfo">
                                <el-autocomplete class="inline-input" v-model="stuInfo" :fetch-suggestions="querySearchStu" placeholder="可输入学号或姓名搜索学生"
                                      :trigger-on-focus="false" @clear="clearSelectStu" clearable style="width:100%;"></el-autocomplete>
                            </el-form-item>
                        </el-row>
                        <el-form-item label="学生" prop="stuCode" v-show="stuAuthVisible || !fieldVisible">
                            {{ applyForm.stuCode + ' - ' + applyForm.stuName }}
                            <el-input v-model="applyForm.stuCode" v-show="false"></el-input>
                        </el-form-item>
                        <el-form-item label="原课程" prop="oriPlanCode" v-show="fieldVisible">
                            <el-select v-model="applyForm.oriPlanCode" filterable placeholder="请选择原课程" style="width:100%;" @change="selectOriCourse">
                                <el-option v-for="item in comboOption.oriCourseInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="原课程名称" prop="oriCourseName" v-show="!fieldVisible">
                            {{ applyForm.oriCourseName }}
                        </el-form-item>
                        <el-form-item label="原课程代码" prop="oriCourseCode">
                            {{ applyForm.oriCourseCode }}
                        </el-form-item>
                        <el-form-item label="原课程类型" prop="oriCourseTypeName">
                            {{ applyForm.oriCourseTypeName }}
                        </el-form-item>
                        <el-form-item label="原学分" prop="oriCredit">
                            {{ applyForm.oriCredit }}
                        </el-form-item>
                        <el-form-item label="原成绩" prop="oriScore">
                            {{ applyForm.oriScore }}
                        </el-form-item>
                        <el-form-item label="现课程" prop="newPlanCode" v-show="fieldVisible">
                            <el-select v-model="applyForm.newPlanCode" filterable placeholder="请选择现课程" style="width:100%;" @change="selectNewCourse">
                                <el-option v-for="item in comboOption.newCourseInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="现课程名称" prop="newCourseName" v-show="!fieldVisible">
                            {{ applyForm.newCourseName }}
                        </el-form-item>
                        <el-form-item label="现课程代码" prop="newCourseCode">
                            {{ applyForm.newCourseCode }}
                        </el-form-item>
                        <el-form-item label="现课程代码" prop="newCourseTypeName">
                            {{ applyForm.newCourseTypeName }}
                        </el-form-item>
                        <el-form-item label="现学分" prop="newCredit">
                            {{ applyForm.newCredit }}
                        </el-form-item>
                        <el-form-item label="申请说明" prop="desc" v-show="fieldVisible">
                            <el-input v-model="applyForm.desc" placeholder="请填写申请说明" autoComplete="on" type="textarea"
                                :rows="5" show-word-limit maxlength="500"></el-input>
                        </el-form-item>
                        <el-form-item label="申请说明" prop="desc" v-show="!fieldVisible">
                            {{ applyForm.desc }}
                        </el-form-item>
                    </el-form>
                </el-scrollbar>

                <div v-if="auditAreaVisible" slot="footer" class="dialog-footer">
                    <audit ref="audit" :itemCode="auditParam" :relatedCode="selectRowData.id" :auditLevel="selectRowData.auditLevel"
                        @auditCallback="auditCallback"></audit>
                </div>

                <div v-if="fieldVisible" slot="footer" class="dialog-footer text-center">
                    <el-button type="primary" :loading="formSubmiting" @click="saveRec">保 存</el-button>
                    <el-button style="margin-left: 10px;" type="success" :loading="formSubmiting" @click="saveAndSubmitRec">提 交</el-button>
                    <el-button style="margin-left: 10px;" @click="dialogVisible = false">取 消</el-button>
                </div>
            </el-dialog>

            <el-dialog class="formDialog" title="审核信息" :visible.sync="auditListDialogVisible" v-if="auditListDialogVisible" width="90%">
                <div>
                    <auditList ref="auditList" :relatedCode="selectRowData.id" :listHeight="450"></auditList>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
    import { confirmMsg, showNotify } from "utils/message";
    import audit from './audit.vue';
    import auditList from './auditList.vue';

    export default {
        components:{
            audit,
            auditList,
        },
        data() {
            return {
                teaAuthVisible: null,
                stuAuthVisible: null,
                comboOption: {
                    auditState: null,
                    oriCourseInfo: null,
                    newCourseInfo: null,
                },
                queryDialogVisible: false,
                queryForm: {
                    pageNum: 1,
                    rowNum: 10,
                    stuCode: null,
                    stuName: null,
                    courseName: null,
                    auditState: null,
                    itemCode: null,
                },
                tableData: [],
                currentPage: 1,
                total: null,
                tableLoading: true,
                selectRowData: {},
                dialogTitle: '',
                dialogVisible: false,
                fieldVisible: true,
                students: [],
                stuInfo: null,
                isAllowApply: false,
                applyForm: {
                    id: '',
                    stuCode: '',
                    stuName: '',
                    oriPlanCode: '',
                    oriCourseCode: '',
                    oriCourseName: '',
                    oriCourseTypeName: '',
                    oriCredit: '',
                    oriScore: '',
                    newPlanCode: '',
                    newCourseCode: '',
                    newCourseName: '',
                    newCourseTypeName: '',
                    newCredit: '',
                    desc: '',
                    submitState: '',
                    auditItemCode: '',
                },
                curdRules: {
                    stuInfo: [{
                        required: true,
                        validator: (rule, value, callback) => {
                            let isExist = false;

                            for(let i=0; i<this.students.length; i++){
                                if(this.students[i].value == this.stuInfo){
                                    this.applyForm.stuCode = this.students[i].stuCode;
                                    this.applyForm.stuName = this.students[i].stuName;
                                    isExist = true;

                                    break;
                                }
                            }

                            if(isExist == false){
                                this.applyForm.stuCode = '';
                                this.applyForm.stuName = '';
                                callback(new Error("学生不存在"));
                            }else{
                                this.loadCourseCombo();
                                callback();
                            }
                        },
                        change: "blur",
                    }],
                    oriPlanCode: [{
                            required: true,
                            message: "请选择原课程",
                            trigger: ["blur", "change"],
                        }
                    ],
                    newPlanCode: [{
                            required: true,
                            message: "请选择原课程",
                            trigger: ["blur", "change"],
                        }
                    ],
                },
                formSubmiting: false,
                auditAreaVisible: false,
                auditListDialogVisible: false,
                auditParam: null,
            };
        },
        created() {
            this.init();
        },
        mounted() {
        },
        methods: {
            async init(){
                await this.queryUserInfo();
                await this.initCombo();
                await this.queryAuditParam();
                await this.queryList();
                await this.checkAllowApply();
            },
            async queryUserInfo() {
                await this.$api.system.basic.userInfo({}).then((res) => {
                    const userInfo = res.data.data;

                    if (userInfo) {
                        let roleInfo = userInfo.roles;

                        for (let roleCode in roleInfo) {
                            // console.log("键：" + roleCode + ",值："+ roleInfo[roleCode]);
                            this.userRole = roleInfo[roleCode];
                        }

                        if(this.userRole == '学生'){
                            this.stuAuthVisible = true;
                            this.applyForm.stuCode = userInfo.phone;
                            this.queryForm.stuCode = userInfo.phone;
                            // this.applyForm.stuCode = '20215060010102';
                            this.applyForm.stuName = userInfo.name;
                            this.queryForm.stuName = userInfo.name;
                            // this.applyForm.stuName = '纪天宇';
                            this.stuInfo = this.applyForm.stuName + ' - ' + this.applyForm.stuCode;
                        }else{
                            this.teaAuthVisible = true;
                        }
                    } else {
                        this.userRole = '访客';
                        this.$router.push('/login');
                    }
                }).catch((err) => {
                    console.log(err);
                });
            },
            showHomePage(){
                this.$router.push('/m/wx/home');
            },
            loadStateImg(row){
                if(row.auditState==='1'){
                    //通过
                    return require('image/mobile/auditState/tg.png');
                }else if(row.auditState==='2'){
                    //驳回
                    return require('image/mobile/auditState/bh.png');
                }else{
                   if(row.submitState === '1'){
                       if(row.auditLevel === '1'){
                           //待审核
                           return require('image/mobile/auditState/dsh.png');
                       }else{
                           //审核中
                           return require('image/mobile/auditState/shz.png');
                       }
                   }else{
                       //未提交
                       return require('image/mobile/auditState/wtj.png');
                   }
                }
            },
            async initCombo() {
                await this.$api.creditIdentified.changeMajor.initCombo({}).then((res) => {
                    this.students = res.data.data.stuData;
                    this.comboOption.auditState = res.data.data.auditStateComboData;
                }).catch((err) => {
                    console.log(err);
                });
            },
            async checkAllowApply(){
                //如果是学生判断是否可申请学分认定
                if(this.stuAuthVisible){
                    for(let i=0; i<this.students.length; i++){
                        if(this.students[i].value == this.stuInfo){
                            this.isAllowApply = true;
                            break;
                        }
                    }
                }
            },
            async queryList() {
                this.tableLoading = true;
                this.queryForm.pageNum = this.currentPage;

                await this.$api.creditIdentified.changeMajor.list({
                    data: this.queryForm,
                }).then((response) => {
                    this.total = response.data.data.total;
                    // this.tableData = response.data.data.list;
                    this.tableData = this.tableData.concat(response.data.data.list);
                    this.tableLoading = false;
                }).catch((error) => {
                    this.tableLoading = false;
                    console.log(error);
                });
            },
            requeryList(){
                this.scrollToTop();
                this.tableData.length = 0;
                this.currentPage = 1;
                this.queryList();
            },
            handleFilter() {
                this.requeryList();
                this.queryDialogVisible = false;
            },
            handleReset() {
                if(this.teaAuthVisible){
                    this.queryForm.stuCode = null;
                    this.queryForm.stuName = null;
                }
                this.queryForm.courseName = null;
                this.queryForm.auditState = null;
                this.tableLoading = false;
                this.queryDialogVisible = false;
                this.requeryList();
            },
            handleScroll(){
                if(this.checkVisible() && !this.tableLoading && this.total>this.tableData.length){
                    this.currentPage++;
                    this.queryList();
                }
            },
            checkVisible() {
                const ele = document.getElementById('loadingTips');
                if(ele){
                    let rect = ele.getBoundingClientRect();
                    //获取当前浏览器的视口高度，不包括工具栏和滚动条
                    //document.documentElement.clientHeight兼容 Internet Explorer 8、7、6、5
                    let viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
                    //bottom top是相对于视口的左上角位置
                    //bottom大于0或者top-视口高度小于0可见
                    return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
                }else{
                    return false;
                }
            },
            scrollToTop(){
                const ele = document.getElementById('listArea');
                if(ele){
                    ele.scrollTop = 0;
                }
            },
            querySearchStu(queryString, cb){
                let students = this.students;
                let results = queryString ? students.filter(this.createFilter(queryString)) : students;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                return (student) => {
                    return (student.value.toLowerCase().indexOf(queryString.toLowerCase()) > -1);
                };
            },
            clearSelectStu(){
                document.activeElement.blur();
            },
            loadCourseCombo(){
                this.$api.creditIdentified.changeMajor.courseCombo({
                    data: {
                        stuCode: this.applyForm.stuCode,
                        oriPlanCode: this.applyForm.oriPlanCode,
                        newPlanCode: this.applyForm.newPlanCode,
                    },
                }).then((res) => {
                    this.comboOption.oriCourseInfo = res.data.data.oriCourseComboData;
                    this.comboOption.newCourseInfo = res.data.data.newCourseComboData;
                }).catch((err) => {
                    console.log(err);
                });
            },
            selectOriCourse(value){
                const courseInfo = this.comboOption.oriCourseInfo;

                for(let i=0; i<courseInfo.length; i++){
                    if(courseInfo[i].comboValue === value){
                        if(courseInfo[i].otherInfo != null){
                            const courseDetailInfo = courseInfo[i].otherInfo.split('@');

                            this.applyForm.oriPlanCode = courseDetailInfo[0];
                            this.applyForm.oriCourseCode = courseDetailInfo[1];
                            this.applyForm.oriCourseName = courseDetailInfo[2];
                            this.applyForm.oriCourseTypeName = courseDetailInfo[3];
                            this.applyForm.oriCredit = courseDetailInfo[4];
                            this.applyForm.oriScore = courseDetailInfo[5];
                        }else{
                            this.$alert("原课程信息不完整，无法申请，可申请其他课程！", "提示", {
                                confirmButtonText: "确定",
                                customClass: 'el-message-box-mobile',
                            });

                            this.applyForm.oriPlanCode = null;
                        }

                        break;
                    }
                }

                //查询是否有相同课程代码的现课程
                const newCourseInfo = this.comboOption.newCourseInfo;
                for(let i =0 ;i<newCourseInfo.length; i++){
                    const newCourseDetailInfo = newCourseInfo[i].otherInfo.split('@');

                    if(newCourseDetailInfo[1] === this.applyForm.oriCourseCode){
                        this.applyForm.newPlanCode = newCourseDetailInfo[0];
                        this.selectNewCourse(newCourseDetailInfo[0]);
                        break;
                    }
                }
            },
            selectNewCourse(value){
                const courseInfo = this.comboOption.newCourseInfo;

                for(let i=0; i<courseInfo.length; i++){
                    if(courseInfo[i].comboValue === value){
                        const courseDetailInfo = courseInfo[i].otherInfo.split('@');

                        this.applyForm.newPlanCode = courseDetailInfo[0];
                        this.applyForm.newCourseCode = courseDetailInfo[1];
                        this.applyForm.newCourseName = courseDetailInfo[2];
                        this.applyForm.newCourseTypeName = courseDetailInfo[3];
                        this.applyForm.newCredit = courseDetailInfo[4];

                        break;
                    }
                }
            },
            addRec(){
                //判断是否允许申请
                if(!this.isAllowApply){
                    this.$alert("没有可申请学分认定的课程", "提示", {
                        confirmButtonText: "确定",
                        customClass: 'el-message-box-mobile',
                    });
                }else{
                    this.dialogTitle = "申请";
                    this.setMainDialogStyle('-65px', '81vh');
                    this.dialogVisible = true;
                    this.applyForm.submitState = '0';
                    this.restoreScroll();

                    if(this.stuAuthVisible){
                        this.loadCourseCombo();
                    }
                }
            },
            modRec(rowData) {
                this.selectRowData = rowData;

                if (this.selectRowData == null) {
                    this.$alert("请先选择一条记录", "提示", {
                        confirmButtonText: "确定",
                        customClass: 'el-message-box-mobile',
                    });

                    return;
                }

                this.dialogTitle = "编辑";
                this.setMainDialogStyle('-65px', '81vh');
                this.dialogVisible = true;
                this.fillForm('edit');
            },
            showDetailInfo(rowData){
                this.selectRowData = rowData;
                this.dialogTitle = '详情';
                this.setMainDialogStyle('-50px', '86vh');
                this.dialogVisible = true;
                this.fieldVisible = false;
                this.fillForm();
            },
            fillForm(type){
                this.$nextTick(() => {
                    this.stuInfo = this.selectRowData.stuName + ' - ' + this.selectRowData.stuCode;
                    this.applyForm.id = this.selectRowData.id;
                    this.applyForm.oriPlanCode = this.selectRowData.oriPlanCode;
                    this.applyForm.oriCourseCode = this.selectRowData.oriCourseCode;
                    this.applyForm.oriCourseName = this.selectRowData.oriCourseName;
                    this.applyForm.oriCourseTypeName = this.selectRowData.oriCourseTypeName;
                    this.applyForm.oriCredit = this.selectRowData.oriCredit;
                    this.applyForm.oriScore = this.selectRowData.oriScore;
                    this.applyForm.newPlanCode = this.selectRowData.newPlanCode;
                    this.applyForm.newCourseCode = this.selectRowData.newCourseCode;
                    this.applyForm.newCourseName = this.selectRowData.newCourseName;
                    this.applyForm.newCourseTypeName = this.selectRowData.newCourseTypeName;
                    this.applyForm.newCredit = this.selectRowData.newCredit;
                    this.applyForm.desc = this.selectRowData.desc;

                    if(this.stuAuthVisible && type==='edit'){
                        this.loadCourseCombo();
                    }
                });

                this.restoreScroll();
            },
            setMainDialogStyle(top, height){
                document.getElementById('mainDialog').style.top = top;
                this.$nextTick(() => {
                    document.getElementById('mainDialogScroll').style.height = height;
                });
            },
            restoreScroll(){
                this.$nextTick(() => {
                    this.$refs.mainDialogScroll.wrap.scrollTop = 0;
                });
            },
            saveRec() {
                this.formSubmiting = true;

                this.$refs['applyForm'].validate((valid) => {
                    if (valid) {
                        this.$api.creditIdentified.changeMajor.save({
                            data: this.applyForm,
                        }).then((response) => {
                            let state = response.data.data.state;
                            let msg = response.data.data.msg;

                            if (state == 'Success') {
                                showNotify('成功', msg ? msg : "保存成功", 'success', 1500);

                                this.requeryList();
                                this.closeDialog();
                            }else{
                                showNotify('失败', msg ? msg : "保存失败", 'error', 3000);
                            }
                        }).catch((error) => {
                            showNotify('错误', error, 'error', 3000);
                        });
                    } else {
                        return false;
                    }
                });

                this.formSubmiting = false;
            },
            saveAndSubmitRec(type){
                confirmMsg('提交后将无法再修改学分认定申请信息，是否继续？', 'el-message-box-mobile').then(() => {
                    this.applyForm.submitState = '1';
                    this.saveRec();
                });
            },
            submitRec(rowData){
                confirmMsg('提交后将无法再修改学分认定申请信息，是否继续？', 'el-message-box-mobile').then(() => {
                    this.$api.creditIdentified.changeMajor.submit({
                        data: {
                            id: rowData.id,
                            auditItemCode: this.applyForm.auditItemCode,
                        },
                    }).then((response) => {
                        let state = response.data.data.state;

                        if (state == 'Success') {
                            showNotify('成功', '提交成功', 'success', 1500);

                            this.requeryList();
                        }else{
                            showNotify('失败', '提交失败', 'error', 3000);
                        }
                    }).catch((error) => {
                        showNotify('错误', error, 'error', 3000);
                    });
                });
            },
            delRec(rowData){
                confirmMsg('是否确定要删除学分认定申请信息？', 'el-message-box-mobile').then(() => {
                    this.applyForm.id = rowData.id;

                    this.$api.creditIdentified.changeMajor.del({
                        data: this.applyForm,
                    }).then((response) => {
                        let state = response.data.data.state;

                        if (state == 'Success') {
                            showNotify('成功', "删除成功", 'success', 1500);

                            this.requeryList();
                        }else{
                            showNotify('失败', "删除失败", 'error', 3000);
                        }
                    }).catch((error) => {
                        showNotify('错误', error, 'error', 3000);
                    });
                });
            },
            closeDialog() {
                this.dialogVisible = false;
                this.fieldVisible = true;
                this.auditAreaVisible = false;

                if(this.$refs['applyForm'] !== undefined){
                    this.$refs['applyForm'].resetFields();
                }
                this.stuInfo = '';
                this.comboOption.oriCourseInfo = null;
                this.comboOption.newCourseInfo = null;
            },
            //查询审核调用参数
            async queryAuditParam(){
                // const pageName = this.$route.path.substring(this.$route.path.lastIndexOf("/")+1);
                const pageName = 'creditIdentified';

                await this.$api.common.audit.auditParam({
                    data: { pageName: pageName },
                }).then((res) => {
                    this.auditParam = res.data.data.auditParam;
                    this.queryForm.itemCode = this.auditParam;
                    this.applyForm.auditItemCode = this.auditParam;
                }).catch((err) => {
                    console.log(err);
                });
            },
            auditRec(rowData){
                this.selectRowData = rowData;
                this.dialogTitle = '审核';
                this.setMainDialogStyle('-60px', '65vh');
                this.dialogVisible = true;
                this.fieldVisible = false;
                this.auditAreaVisible = true;
                this.fillForm();
            },
            //审核后回调函数
            auditCallback(auditInfo){
                this.dialogVisible = false;
                auditInfo.stuCode = this.selectRowData.stuCode;
                auditInfo.oriPlanCode = this.selectRowData.oriPlanCode;

                this.updateStuScoreState(auditInfo);
            },
            //完成审核后更新学生信息
            updateStuScoreState(auditInfo){
                this.$api.creditIdentified.changeMajor.updateAuditState({
                    data: auditInfo,
                }).then((response) => {
                    let state = response.data.data.state;
                    if(state == 'Success'){

                    }else{
                        showNotify('失败', '成绩信息更新失败', 'error', 3000);
                    }

                    this.requeryList();
                }).catch((error) => {
                    showNotify('错误', error, 'error', 3000);
                });
            },
            //显示审核详情列表
            showAuditList(rowData){
                this.selectRowData = rowData;
                this.auditListDialogVisible = true;
            },
        }
    };
</script>
<style src="styles/mobile.css"></style>
<style scoped>
    #mobileMode {
        line-height: 0;
    }

    #mobileMode #queryDialog {
        top: 150px;
    }

    #mobileMode #mainDialogScroll {
        height: 65vh;
        padding: 10px 20px;
    }

    #mobileMode #loadingTips {
        height: 30px;
        line-height: 30px;
        color: #9d9d9d;
        position: relative;
        bottom: 0;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// creditIdentified.vue?03c978fd